import selectLanguages from './selectLanguages';
import selectFeatures from './selectMainFeatures';

export default {
  selectLanguageData: selectLanguages, selectMainFeatures: selectFeatures,
};
